const getLocalStorage = (): Storage | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

export const safeLocalStorageGet = (key: string): string | null => {
  try {
    return getLocalStorage()?.getItem(key) ?? null;
  } catch {
    return null;
  }
};

export const safeLocalStorageSet = (key: string, value: string): boolean => {
  try {
    const storage = getLocalStorage();
    if (!storage) {
      return false;
    }
    storage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
};

export const safeLocalStorageRemove = (key: string): boolean => {
  try {
    const storage = getLocalStorage();
    if (!storage) {
      return false;
    }
    storage.removeItem(key);
    return true;
  } catch {
    return false;
  }
};
